<template>
	<div class="cog-field" :class="'cog-col ' + colNumClass">
		<label class="cog-label" :for="fieldId">
			{{ label }}</label>
		<slot></slot>
	</div>
</template>

<script>
	import Col from './Col.vue';

	export default {
		name: 'CFieldNoSource',
		mixins: [Col],
		props: {
			fieldId: {
				type: String,
				default: null
			},
			label: {
				type: String,
				default: null
			}
		}
	};
</script>